// extracted by mini-css-extract-plugin
module.exports = {"navButton":"navButton--SNuUC"};